// This module never loads the catalog or uses its local cache. Liquid decides access.
const gate = document.querySelector('[data-bf-launch-state]');
if (gate) {
  const back = gate.querySelector('[data-bf-launch-back]');
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  if (preview) { const url = new URL(back.href); url.searchParams.set('preview_theme_id', preview); back.href = url.href; }
  if (gate.dataset.bfLaunchBehavior === 'redirect') {
    location.replace(back.href);
  } else if (gate.dataset.bfLaunchState === 'waiting') {
    const end = Number(gate.dataset.bfLaunchEnd) * 1000;
    const serverNow = Number(gate.dataset.bfServerNow) * 1000;
    const started = performance.now();
    const status = gate.querySelector('[data-bf-launch-status]');
    const values = [...gate.querySelectorAll('[data-bf-launch-value]')];
    const time = gate.querySelector('time');
    if (time) time.textContent = new Intl.DateTimeFormat('ro-RO', { dateStyle: 'long', timeStyle: 'short', timeZone: 'Europe/Bucharest' }).format(end) + ' · ora României';
    let checking = false, nextCheck = 0, stopped = false;
    let currentController;
    const recheck = async () => {
      if (checking || stopped || performance.now() < nextCheck) return;
      checking = true; nextCheck = performance.now() + 15000;
      status.textContent = 'Verificăm deschiderea ofertelor…';
      const url = new URL(location.href);
      url.searchParams.set('bf_launch_check', String(Math.floor(performance.timeOrigin + performance.now())));
      currentController = new AbortController();
      const timeout = setTimeout(() => currentController.abort(), 10000);
      try {
        const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: currentController.signal });
        if (!response.ok) throw new Error('Unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        // No browser-clock or URL bypass: navigate only after a new server response is active.
        if (doc.querySelector('bf-catalog [data-bf-config]') && !doc.querySelector('[data-bf-launch-state]')) {
          stopped = true; location.replace(url.href); return;
        }
        const state = doc.querySelector('[data-bf-launch-state]')?.dataset.bfLaunchState;
        if (state === 'closed' || state === 'invalid') stopped = true;
        status.textContent = state === 'closed' || state === 'invalid' ? 'Campania nu este disponibilă momentan.' : 'Lansarea se pregătește. Verificăm din nou în câteva secunde.';
      } catch { status.textContent = 'Nu am putut verifica lansarea. Reîncarcă pagina pentru a încerca din nou.'; }
      finally { clearTimeout(timeout); checking = false; }
    };
    const update = () => {
      const seconds = Math.max(0, Math.ceil((end - serverNow - (performance.now() - started)) / 1000));
      const parts = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      values.forEach((value, i) => { value.textContent = String(parts[i]).padStart(2, '0'); });
      if (!seconds) void recheck();
    };
    update(); const timer = setInterval(update, 1000);
    window.addEventListener('pagehide', () => { stopped = true; clearInterval(timer); currentController?.abort(); }, { once: true });
  }
}
